export const ENERGY_DATA = '/energy-data'
export const ENERGY_DATA_AGGREGATED = '/energy-data/aggregated'
export const FORECAST = '/forecast'
export const CONSUMPTION_TRENDS = '/trends/consumption'
export const CONSUMPTION = '/functions/consumption'
export const PEAKLOAD_TRENDS = '/trends/peakload'
export const LOAD_PROFILE_DETAILS = '/details/load-profile'
export const EFFICIENCY = '/efficiency'
export const DASHBOARD_DATA_URL = '/v1/dashboard'
export const MARKET = '/v1/market'
export const INFRA_MODULE_REQUEST = '/infra-module-request'

export const LOCATIONS_V2 = '/calculations/locations'
export const LOCATIONS = '/v1/locations/stats'

export const SPOT_MARKET = '/spot-market'
export const PROCUREMENT_CONTRACT = '/procurement/contract'
export const PROCUREMENT_MODEL = '/procurement/model'
export const MEASURE_VALERI_CALCULATION_EXPORT = '/iso/measures/{id}/valeri/calculation-result/export'
export const VALERI_CALCULATION_EXPORT = '/iso/valeri/{id}/calculation-result/export'
export const SSO_STRATEGIES = '/auth/sso/strategies'
